export { SpeechRecognizerManager, isSpeechRecognitionSupported } from './SpeechRecognizerManager';
export { SttDataCollector } from './SttDataCollector';

export type {
  SttSegment,
  SpeechRecognizerConfig,
  SpeechRecognizerCallbacks,
} from './SpeechRecognizerManager';
